import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

function ProtectedRoute ({children, allowedRoles = []}) {

    const { auth, logout } = useContext(AuthContext);

    if (auth.access_token == null) {
        return <Navigate to="/login" />
    }

    // Redirect for Un-Authorized Trades
    if (allowedRoles.length && !allowedRoles.includes(auth.user.role)) {
        console.log("Un-Authenticated");
        logout();
    }

    return children
}

export default ProtectedRoute;
